<script lang="ts" setup>
  import { useEnvironmentsStore } from '@/stores/environments';
  import { getDocsUrl, isSafeUrl } from '@/utils/branding';

  const { t, locale } = useI18n({
    messages: {
      ru: {
        docsLink: 'Документация',
        ...(JSON.parse(
          (window.__VITE_ENVS.FOOTER_TRANSLATIONS_RU as string) ?? '{}',
        ) as Record<string, string>),
        version: 'Версия облака: {version}',
      },
      en: {
        docsLink: 'Documentation',
        ...(JSON.parse(
          (window.__VITE_ENVS.FOOTER_TRANSLATIONS_EN as string) ?? '{}',
        ) as Record<string, string>),
        version: 'Cloud version: {version}',
      },
    },
  });

  const environmentsStore = useEnvironmentsStore();

  const docsUrl = computed(() => getDocsUrl(locale.value));

  const links = (
    JSON.parse((window.__VITE_ENVS.FOOTER_LINKS as string) ?? '[]') as Array<{
      caption: string;
      url: string;
    }>
  ).filter((link) => isSafeUrl(link.url));
</script>

<template>
  <footer
    class="container-fluid sticky top-[100vh] border-t-[1px] border-gray py-24 flex justify-between gap-16 items-center flex-wrap">
    <VLogo />
    <nav class="flex flex-wrap gap-24 align-middle">
      <a
        v-if="docsUrl && t('docsLink')"
        :href="docsUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="link">
        {{ t('docsLink') }}
      </a>
      <!-- A link renders only when it has both a valid url and a non-empty caption -->
      <template v-for="(link, i) in links" :key="i">
        <a
          v-if="t(link.caption)"
          :href="link.url"
          target="_blank"
          rel="noopener noreferrer"
          class="link">
          {{ t(link.caption) }}
        </a>
      </template>
      <div
        v-if="environmentsStore.IS_ON_PREMISE"
        class="flex text-gray-hover flex-row-reverse">
        {{ t('version', { version: environmentsStore.ON_PREMISE_VERSION }) }}
      </div>
      <VLanguageSwitch />
    </nav>
  </footer>
</template>
